import type {FC} from 'react';
import {memo} from 'react';

import ArrowNext from '@yourcoach/shared/assets/icons/arrow-next.svg';

interface Props {
  customClass?: string;
  height?: string;
  viewBox?: string;
  width?: string;
}

const IconNext: FC<Props> = ({
  customClass = '',
  height = '100%',
  viewBox = '5 5 20 20',
  width = '100%',
}) => {
  return (
    <ArrowNext
      className={`${customClass}`}
      fill="#819AA9"
      height={width}
      viewBox={viewBox}
      width={height}
    />
  );
};

export default memo(IconNext);
